<template>
  <div class="sidebar">
    <h2>{{$ml.get(`Users`)}}</h2>
    <div class="list">
      <div>
        <SearchInput v-model="search"/>
      </div>
      <div class="scroller">
        <SelectorOverlayContainer
          :value="$route.params.subId"
          :react-on="serchUsers"
          ref="overlay"
        >
          <SelectorOverlayItem
            v-for="item in serchUsers"
            :key="item.id"
          >
            <UserItem :data="item" />
          </SelectorOverlayItem>
        </SelectorOverlayContainer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchInput from '@/components/common/SearchInput'
import {
  SelectorOverlayContainer,
  SelectorOverlayItem
} from '@/components/common/selector-overlay'
import UserItem from '@/components/subAccount/sidebar/UserItem'


export default {
  data () {
    return {
      search: '',
    }
  },
  components: {
    SearchInput,
    SelectorOverlayContainer,
    SelectorOverlayItem,
    UserItem
  },
  computed: {
    ...mapGetters({
      users: 'subAccount/users',
    }),
    serchUsers () {
      var res = this.users;
      if (this.search != '')
        res = res.filter(item => {
          if (item.firstName.indexOf(this.search) != -1 || item.lastName.indexOf(this.search) != -1)
            return true;

          return false;
        });

      return res;
    }
  },
}
</script>

<style lang="scss" scoped>
  .sidebar {
    width: 300px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-right: 8px;

    .head {
      text-align: start;
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 33px;
      color: #4C5056;
      display: flex;
      align-items: center;
    }
    .list {
      height: 100%;
      width: 100%;
      background: white;
      border-radius: 5px;

      >div:first-child {
        padding: 16px 30px;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          width: calc(100% - 30px);
          height: 0.5px;
          background: #E4E5E6;
          bottom: 0;
          left: 15px;
        }
      }

      .scroller {
        padding: 0 15px;
      }
    }
  }
</style>
